import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(() => ({
  cardButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 150,
    margin: 5,
    height: 120,
    padding: 16,
    borderRadius: 8,
    transition: 'background-color 0.3s ease-in-out',
  },
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 8,
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
  numbers: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}))

const RoadMapCardButton = ({ item, onSelect, isSelected }) => {
  const classes = useStyles()

  return (
    <Card
      className={classes.cardButton}
      style={{
        backgroundColor: isSelected ? item.color : '#fff',
      }}
    >
      <CardContent>
        <Button
          className={classes.cardButton}
          onClick={() => onSelect(item)}
          type="button"
        >
          <div className={classes.numbers}>
            <Typography variant="h6" component="h3" className={classes.title}>
              {item?.completos} / {item?.total}
            </Typography>

            <Typography variant="h6" component="h3" className={classes.title}>
              {item?.nombre}
            </Typography>
          </div>
        </Button>
      </CardContent>
    </Card>
  )
}

export { RoadMapCardButton }
